import './firewall.scss'

import { faCircleNotch, faExclamationTriangle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { first } from 'rxjs/operators';
import { Component, Watch } from 'vue-property-decorator';

import { AuthService, User } from '@skinsoft/auth';
import { DEFAULT_PROXY } from '@skinsoft/data-store';
import { AliasDataStore as CollaboratorDataStore } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';

declare var WORKSPACE_ID: string;

@Component({
    props: ['collabWarningMessage', 'noGroupForUserWarningMessage'],
    template: require('./firewall.html'),
})
export class Firewall extends ReactiveVue {
    public collabWarningMessage: string;
    public noGroupForUserWarningMessage: string;
    public $authService: AuthService;
    public user: User | null = null as any;

    private userHasCollaborator: boolean = false;
    private isUserInGroup: boolean = true;
    private showCollabWarning: boolean = true;
    private collabRequestPending: boolean = true;
    private groupRequestPending: boolean = true;

    private $collaboratorDataStore: CollaboratorDataStore;

    // Icons
    private warningIcon = faExclamationTriangle;
    private closeIcon = faTimes;
    private loadingIcon = faCircleNotch;

    public created() {
        this.subscribeTo(this.$authService.user$, (user: User | null) => {
            this.reset();
            this.user = user;
            if (user) {

                // Checking that user is part of a group
                DEFAULT_PROXY.fetch("/groups/userGroup", {
                    userId: user.id,
                    workspace: WORKSPACE_ID
                }).pipe(first()).toPromise()
                    .then(
                        group => {
                            this.groupRequestPending = false;
                            this.isUserInGroup = !!group;
                        }
                    )
                    .catch(
                        error => {
                            this.groupRequestPending = false;
                            this.isUserInGroup = false;
                        }
                    )

                // Checking that user has an associated collaborator
                this.$collaboratorDataStore.getCollaboratorByUserId(user.id).pipe(first()).toPromise()
                    .then(
                        collab => {
                            this.userHasCollaborator = !!collab;
                            this.showCollabWarning = !this.userHasCollaborator;
                            this.groupRequestPending = false;
                        }
                    ).catch(
                        error => {
                            this.userHasCollaborator = false;
                            this.showCollabWarning = true;
                            this.groupRequestPending = false;
                        }
                    );
            }
        });
    }

    public mounted() {
        this.reset();
    }

    private reset() {
        this.userHasCollaborator = false;
        this.isUserInGroup = true;
        this.showCollabWarning = false;

        this.collabRequestPending = true;
        this.groupRequestPending = true;
    }

    private get authorized() {
        return !!this.user;
    }

    private get pending() {
        return this.collabRequestPending && this.groupRequestPending;
    }
}
